import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forecastactualweeklyfinland',
  templateUrl: './forecastactualweeklyfinland.component.html',
  styleUrls: ['./forecastactualweeklyfinland.component.css']
})
export class ForecastactualweeklyfinlandComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
